const copyClipboard = (event) => {
   if (window.isSecureContext) {
      navigator.clipboard.writeText(window.location.href);
      const copySuccess = document.querySelector('[data-copy-success]');
      copySuccess.classList.remove('copy-success-message-active');
      setTimeout(() => copySuccess.classList.add('copy-success-message-active'), 3000);
   } else {
      event.target.style.display = 'none';
   }
};

export default copyClipboard;